import React from 'react';
import { useTranslation } from 'react-i18next';
import noImage from '../../../../../assets/images/no-image.png';
import { DeleteIcon, UploadIcon } from '../../../../../bombiix-icon';

export function CompanyStampConfig({ obj, getImage, handleUploadImage, handleRemoveImage }) {
  const { t } = useTranslation('common');
  const filePreview = (element) => {
    return element ? encodeURI(`https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${element}`) : '';
  };

  const getImageSrc = () => {
    return obj?.companyLogo.includes('base64') ? getImage(obj?.companyLogo) : filePreview(obj?.companyLogo);
  };
  return (
    <div className="p-3">
      <div className="text-center p-3">
        <div className="image-upload-container">
          <figure>
            <img className="img-thumb" src={getImageSrc() || noImage} alt="" />
          </figure>
          <div className="btn-container">
            <button type="button" onClick={() => handleUploadImage('Company Stamp')} className="btn">
              <span className="sr-only">{t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.COMPANY_STAMP_CONFIG.UPLOAD_IMAGE')}</span>
              <UploadIcon size={24} className="mr-2" />
            </button>
            {obj?.companyLogo !== '' && (
              <button type="button" onClick={() => handleRemoveImage('Company Stamp')} className="btn">
                <span className="sr-only">{t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.COMPANY_STAMP_CONFIG.DELETE_IMAGE')}</span>
                <DeleteIcon size={24} className="mr-2" />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompanyStampConfig;
